import "./Loader.scss"

const Loader = () => {
	return (
		<div className="loader-icon">
			<svg className="icon icon-loading" />
		</div>
	);
};

export default Loader;
